// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__21jvi","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__zEcib"};